import React, { ReactElement } from 'react'
import { makeStyles, Grid } from '@material-ui/core';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useIntl } from 'react-intl';
import KTR105 from '../Clampexsets/KTR105';
import KTR130 from '../Clampexsets/KTR130';
import KTR131 from '../Clampexsets/KTR131';
import KTR200 from '../Clampexsets/KTR200';
import KTR203 from '../Clampexsets/KTR203';
import KTR400 from '../Clampexsets/KTR400';


const useStyle = makeStyles({
  cardTop: {
    margin: "10px",
    height: "360px"
  },
  card: {
    margin: "10px"
  }
});

export default function WithAxialHubShifting(): ReactElement {
  const classes = useStyle();
  let { path } = useRouteMatch();
  const { formatMessage: f } = useIntl();


  return (
    <React.Fragment>
      <h2>{f({ id: 'app.selfcent.heading' })}</h2>
      <Grid container style={{ marginTop: "20px" }} justify="center">
        <Grid item>
          <KTR105 className={classes.cardTop} />
        </Grid>
        <Grid item>
          <KTR130 className={classes.cardTop} />
        </Grid>
        <Grid item>
          <KTR131 className={classes.cardTop} />
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: "20px" }} justify="center">
        <Grid item>
          <KTR200 className={classes.card} />
        </Grid>
        <Grid item>
          <KTR203 className={classes.card} />
        </Grid>
        <Grid item>
          <KTR400 className={classes.card} />
        </Grid>
      </Grid>
      <Switch>
        <Route path={`${path}/axialhs`} component={WithAxialHubShifting}></Route>
        <Route path={`${path}/woaxialhs`} component={WithAxialHubShifting}></Route>
      </Switch>
    </React.Fragment>
  )
}
